const parsedVideoDurationMin = Number.parseInt(__ATLAS_CLOUD_VIDEO_DURATION_MIN__, 10);
const parsedVideoDurationMax = Number.parseInt(__ATLAS_CLOUD_VIDEO_DURATION_MAX__, 10);

export const VIDEO_DURATION_MIN_SECONDS =
  Number.isFinite(parsedVideoDurationMin) && parsedVideoDurationMin > 0
    ? parsedVideoDurationMin
    : 3;

export const VIDEO_DURATION_MAX_SECONDS =
  Number.isFinite(parsedVideoDurationMax) && parsedVideoDurationMax >= VIDEO_DURATION_MIN_SECONDS
    ? parsedVideoDurationMax
    : Math.max(VIDEO_DURATION_MIN_SECONDS, 7);

/**
 * The selectable whole-second durations a user may pick for an AI video,
 * inclusive of both the configured minimum and maximum.
 */
export const VIDEO_DURATION_OPTIONS = Array.from(
  { length: VIDEO_DURATION_MAX_SECONDS - VIDEO_DURATION_MIN_SECONDS + 1 },
  (_, index) => VIDEO_DURATION_MIN_SECONDS + index
);

export function clampVideoDurationSeconds(value: unknown) {
  const parsedValue = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(parsedValue)) {
    return VIDEO_DURATION_MIN_SECONDS;
  }

  return Math.min(
    Math.max(Math.round(parsedValue), VIDEO_DURATION_MIN_SECONDS),
    VIDEO_DURATION_MAX_SECONDS
  );
}

/**
 * Total credit cost for an AI video: the per-second price (the
 * `pricePerVideoSecond` site setting) multiplied by the chosen duration.
 */
export function getVideoGenerationCreditCost(pricePerVideoSecond: number, durationSeconds: unknown) {
  const normalizedPerSecond =
    Number.isFinite(pricePerVideoSecond) && pricePerVideoSecond > 0
      ? Math.trunc(pricePerVideoSecond)
      : 0;

  return normalizedPerSecond * clampVideoDurationSeconds(durationSeconds);
}
